/**
 * Link token capture — runs before anything else in the entry module.
 *
 * Email links carry a single-use token in the query string (/verify-email?token=…,
 * /reset-password?token=…). The analytics script records the first pageview with the
 * full URL, so the token must leave the address bar before that script executes.
 * This module is the first import of main.tsx, and the analytics tag sits after the
 * entry module in index.html, so document order guarantees this strip runs first.
 *
 * The token is held in memory for the page that needs it; a page reads it with
 * takeLinkToken() and falls back to the URL for any load where this did not run.
 */

const TOKEN_ROUTES = new Set(['/verify-email', '/reset-password']);

let linkToken: string | null = null;

if (typeof window !== 'undefined' && TOKEN_ROUTES.has(window.location.pathname)) {
  const params = new URLSearchParams(window.location.search);
  const token = params.get('token');
  if (token) {
    linkToken = token;
    params.delete('token');
    const rest = params.toString();
    const clean = window.location.pathname + (rest ? `?${rest}` : '') + window.location.hash;
    window.history.replaceState(window.history.state, '', clean);
  }
}

/** The token captured from the email link for this page load, or null. */
export function takeLinkToken(): string | null {
  return linkToken;
}
